import { simpleCopy } from '@/utils/deepCopy';
import { IMvpInventory } from '../entities/inventory';
import { DateService } from './dateService';
import { IYearMonth } from '../date';
import { IBusiness } from '../entities/businessBase';

/**
 * 在庫情報を操作するためのサービス
 * 在庫情報はinventoryとmvpInventoryがあるが、どっち向けに作る必要があるんだ？
 * TODO: 一旦深くはやらず、必要なのだけまとめる
 */
export class InventoryService {
  /**
   * mvpInventory配列の中から、同一年月の数量情報を合算して一つにまとめて返す
   * @param inventoryArray - 在庫情報
   */
  public static sumInventoryAmountInYearMonth(inventoryArray: IMvpInventory[] | undefined): IMvpInventory[] {
    if (!inventoryArray || inventoryArray.length === 0) return [];
    const targetInventoryArray = simpleCopy(inventoryArray);
    const output: IMvpInventory[] = []; // 出力用の配列

    // 年月情報のSetを作成する(ここでの重複は認めない)
    const yearMonthSet: Set<string> = new Set();
    for (const targetInventory of targetInventoryArray) {
      // 年_月の文字列をSetに追加していく
      const yearMonthStr = DateService.serialize(targetInventory);
      yearMonthSet.add(yearMonthStr);
    }

    // 年月が重複する在庫情報の合算処理を行う
    for (const targetYearMonth of yearMonthSet) {
      // 判定に用いるIYearMonthオブジェクトの作成
      const yearMonth: IYearMonth = {
        year: Number(targetYearMonth.split('_')[0]),
        month: Number(targetYearMonth.split('_')[1]),
      };

      // 在庫配列から同一年月の情報のみ取り出す
      const filteredInventoryArray: IMvpInventory[] = targetInventoryArray.filter((target) =>
        DateService.equalYearMonthInfo(target, yearMonth)
      );

      // 合算処理
      for (const inventory of filteredInventoryArray) {
        // 出力用の配列内から探す
        const alreadyExistArrivalIndex = output.findIndex((item) => DateService.equalYearMonthInfo(item, yearMonth));
        // 出力用配列への追加・更新
        if (alreadyExistArrivalIndex !== -1) {
          // 同一年月の在庫情報があるなら、すでにある数量に加算して更新を行う
          output[alreadyExistArrivalIndex] = {
            year: Number(yearMonth.year),
            month: Number(yearMonth.month),
            amount: (output[alreadyExistArrivalIndex].amount ?? 0) + inventory.amount,
          };
        } else {
          // 同一年月の在庫情報がない場合、配列にpushする
          output.push({ year: Number(yearMonth.year), month: Number(yearMonth.month), amount: inventory.amount });
        }
      }
    }

    // 年月順にソートする
    output.sort((a, b) => {
      return DateService.compareYearMonths(a, b);
    });

    return output;
  }

  /**
   * 取引情報一覧から、年月が最新の在庫情報の年月情報のみを取得する
   * @param getBusinesses - 取引情報
   */
  public static getLatestInventory = (getBusinesses: IBusiness[]): IYearMonth => {
    // 変更されると困るので、simpleCopyしとく
    const businesses: IBusiness[] = simpleCopy(getBusinesses);
    // 出力用の年月オブジェクト
    let outputYearMonth: IYearMonth = { year: 0, month: 0 };
    // 在庫情報のみをまとめる
    businesses.forEach((business) => {
      if (business.mvpInventory && business.mvpInventory.length !== 0) {
        business.mvpInventory.forEach((inventory) => {
          // 在庫情報が最新の年月のものを探す
          if (
            inventory.year > outputYearMonth.year ||
            (inventory.year === outputYearMonth.year && inventory.month > outputYearMonth.month)
          ) {
            // 在庫情報が最新の年月のものは更新される
            outputYearMonth = { year: inventory.year, month: inventory.month };
          }
        });
      } else {
        return;
      }
    });
    return outputYearMonth;
  };
}
